import { locales } from '../constants/locale-map';
import { DEFAULT_LOCALE } from '../constants';
import { findSupportedLocale } from './find-supported-locale';
export const verifySupportedLocale = (userType, locale) => {
    const currentLocale = findSupportedLocale(locale) || locale;
    const vocabularyData = locales[currentLocale];
    const isUserSupportLocale = vocabularyData && vocabularyData[userType];
    if (isUserSupportLocale)
        return currentLocale;
    return DEFAULT_LOCALE;
};
